import { inViewMargin } from '@helpers/animate';
import { until } from '@helpers/media';
import { withMotion } from '@hoc/withMotion';
import { useAutoplay } from '@hooks/useAutoplay';
import { useInView } from '@hooks/useInView';
import * as React from 'react';
import { useMedia } from 'react-use';
import S, { LayoutBreakpoint } from './MarketSectorsSection.styles';
import SectionDetail from './SectionDetail/SectionDetail';
import SectionItem from './SectionItem/SectionItem';
const MarketSectorsSection = ({ autoplay = 0, content, id, items, title, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    const isAccordion = useMedia(until(LayoutBreakpoint), true);
    const { activeIndex, duration, paused, setActiveIndex, setPaused } = useAutoplay({
        enabled: !isAccordion && autoplay > 0,
        duration: autoplay,
        items: items,
    });
    React.useEffect(() => {
        setPaused(!inView);
    }, [inView]);
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-inview": inView },
        React.createElement(S.Inner, null,
            (title || content) && (React.createElement(S.IntroContent, null,
                title && (React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title)),
                content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content } }))),
            React.createElement(S.GridContainer, null,
                React.createElement(S.ItemList, null, items.map((item, index) => (React.createElement(SectionItem, { key: item.id, ...item, active: index === activeIndex, duration: duration, paused: paused, onClick: () => {
                        setActiveIndex(index);
                        setPaused(true);
                    } })))),
                React.createElement(S.DetailList, null, items.map((item, index) => (React.createElement(SectionDetail, { key: item.id, ...item, active: index === activeIndex }))))))));
};
export default withMotion(MarketSectorsSection);
